import React from "react";
import { Box } from "@mui/material";
import Header from "components/layout/Header";


const Overview = () => {
  

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="OVERVIEW page TBD"
        subtitle="Overview of general revenue and profit TBD"
      />
      <Box height="75vh">
        TBD
      </Box>
    </Box>
  );
};

export default Overview;